import championship from "../constants/championship";


export const championships = (state = [], action) => {
    switch (action.type) {
        case championship.DELETE_CHAMPIONSHIP:
            return state.toSpliced(action.index, 1);

        case championship.UPDATE_ALL_CHAMPIONSHIPS:
            return [...action.championships];

        case championship.ADD_CHAMPIONSHIP_TO_STORAGE:
            return [...state, action.championship];

        case championship.UPDATE_CHAMPIONSHIP_INFO_IN_STORAGE:
            let champs = [...state];
            champs.splice(action.index, 1, action.champ);
            return [...champs];

        case championship.CHANGE_CHAMP_STATE:
            let new_state = [...state];
            new_state.splice(action.index, 1, {...state[action.index], state: action.state});
            return [...new_state ];

        case championship.UPDATE_CHAMP:
            return [...state];

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// src/reducers/championships.jsx